import React, { useState } from "react";
import InventoryRequestPickerModal from "../../modals/InventoryRequestPickerModal";
import BulkAddToOrderProgressModal from "./BulkAddToOrderProgressModal";

export default function BulkAddToOrderModal({ selectedIds, onClose, onComplete }) {
  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleSelectOrder = order => {
    setSelectedOrder(order);
  };

  const handleProgressComplete = () => {
    onComplete();
  };

  if (!selectedOrder) {
    return (
      <InventoryRequestPickerModal
        type="orders"
        onClose={onClose}
        onSelect={order => handleSelectOrder(order)}
      />
    );
  }

  return (
    <BulkAddToOrderProgressModal
      selectedIds={selectedIds}
      inventoryRequestId={selectedOrder.id}
      selectedOrder={selectedOrder}
      onClose={onClose}
      onComplete={handleProgressComplete}
    />
  );
}
